module.exports = __webpack_public_path__ + "img/5.eea4ff68.svg";